import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { notification } from 'antd';
import { IExchangeCodeResponse } from 'src/types/token';
import { saveIdToken, saveRefreshToken, saveToken, getToken } from 'src/utils/local-storage';

function getQueryString(data = {}) {
  return Object.entries(data)
    .map(([key, value]: any[]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
}

export const requestToken = async (code: string, secret: string, clientId: string) => {
  try {
    const response = await axios({
      auth: {
        username: clientId,
        password: secret,
      },
      method: 'POST',
      baseURL: process.env.REACT_APP_AUTH_URL,
      url: '/oauth2/token',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      data: {
        grant_type: 'authorization_code',
        code,
        redirect_uri: `${process.env.REACT_APP_URL}/callback`,
        client_id: clientId,
      },
      transformRequest: getQueryString
    });
    const tokenPayload: IExchangeCodeResponse = response.data;
    saveToken(tokenPayload.access_token);
    saveIdToken(tokenPayload.id_token);
    saveRefreshToken(tokenPayload.refresh_token);
    window.location.reload();
    return response;
  } catch (error) {
    console.log(error)
    notification.error({
      message: 'Error',
      description: error.response.data.error_description
    });
    throw error
  }
}

export const requestRefreshToken = async (refreshToken: string, secret: string) => {
  try {
    const decoded: any = jwtDecode(getToken());
    const response = await axios({
      auth: {
        username: decoded.client_id,
        password: secret,
      },
      method: 'POST',
      baseURL: process.env.REACT_APP_AUTH_URL,
      url: '/oauth2/token',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      data: {
        grant_type: 'refresh_token',
        client_id: decoded.client_id,
        refresh_token: refreshToken,
      },
      transformRequest: getQueryString
    });
    const tokenPayload: IExchangeCodeResponse = response.data;
    saveToken(tokenPayload.access_token);
    saveIdToken(tokenPayload.id_token);
    saveRefreshToken(tokenPayload.refresh_token);
    window.location.reload();
  } catch (error) {
    console.log(error)
    throw error
  }
}

export const unlink = async () => {
  try {
    const response = await axios({
      method: 'DELETE',
      baseURL: process.env.REACT_APP_API_URL,
      url: '/g/customer/unlink',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': `Bearer ${getToken()}`,
        'DeviceId': '34567bbdnvbver',
      },
    });
    // window.location.href = response.request.responseURL;
    return response;
  } catch (error) {
    console.log(error)
    notification.error({
      message: 'Error',
    });
    throw error
  }
}

export const requestMerchantToken = async (clientId: string, secret: string, audience: string, scope: string) => {
  try {
    const response = await axios({
      auth: {
        username: clientId,
        password: secret,
      },
      method: 'POST',
      baseURL: process.env.REACT_APP_AUTH_URL,
      url: '/oauth2/token',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      data: {
        grant_type: 'client_credentials',
        scope,
        audience,
      },
      transformRequest: getQueryString
    });
    const tokenPayload: IExchangeCodeResponse = response.data;
    return tokenPayload;
  } catch (error) {
    console.log(error)
    notification.error({
      message: 'Error',
      description: error.response.data.error_description
    });
    throw error
  }
}
